<template>
  <div class="device-code-validation">
    <p v-if="state === 'checking'">{{ $t('checking_device_code') }}</p>
    <p v-else-if="state === 'duplicate'" class="error">{{ duplicateMessage }}</p>
    <p v-else-if="state === 'error'" class="error">{{ errorMessage || $t('device_code_lookup_failed') }}</p>
  </div>
</template>

<script>
export default {
	props: {
		state: { type: String, default: 'idle' },
		duplicateMessage: { type: String, default: '' },
		errorMessage: { type: String, default: '' },
	},
};
</script>

<style lang="scss" scoped>
.device-code-validation {
	min-height: 20px;
	margin: 6px 0 0;
	font-size: 13px;
	line-height: 1.4;
	color: #666;
	word-break: break-word;

	p {
		margin: 0;
	}

	.error {
		color: #c0392b;
	}
}

@media (max-width: 480px) {
	.device-code-validation {
		font-size: 12px;
	}
}
</style>
